var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ 'vlr-neg': parseFloat(_vm.valor)<0, 
                'vlr-pos': parseFloat(_vm.valor)>=0 }},[_vm._v(_vm._s(_vm._f("toCurrency")(parseFloat(_vm.valor))))])}
var staticRenderFns = []

export { render, staticRenderFns }